import { z } from 'zod';
export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 25;
/** True for a real calendar date written YYYY-MM-DD (rejects 2026-13-45 and 2026-02-30). */
export function isRealDate(value) {
    const time = Date.parse(`${value}T00:00:00Z`);
    return !Number.isNaN(time) && new Date(time).toISOString().startsWith(value);
}
/** Shared primary-key schema. All entities use UUIDs. */
export const uuidSchema = z.string().uuid();
/** Query-string pagination. Values arrive as strings, so they are coerced. */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
/** SQL offset for a validated pagination query. */
export function toOffset({ page, pageSize }) {
    return (page - 1) * pageSize;
}
export { z };
//# sourceMappingURL=common.js.map